import { useEffect, useState } from "react";
import { Animated } from 'react-animated-css';
import { EqualHeight, EqualHeightElement } from 'react-equal-height';
import { Link } from 'react-router-dom';
import HomePageController from '../../apis/controller/homePage.controller';
import { images } from '../../assets/images';
import { dateFormat } from "../../Components/helper/date";
import { charLimit, stripTags } from "../../Components/helper/General";
import { renderImage } from "../../Components/helper/image";
import { routes } from '../../routes';
import { AccoladesSlider } from './accolades';
import { ArticlesSlider } from './articles';
import { HomeSlider } from './slider/index';
import { TechnologiesSlider } from './technologies';
import { TestimonialSlider } from './testimonials';

function HomePage() {
	const [homepage, setHomepage] = useState();
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		getHomepage();
		window.scrollTo(0, 0);
	}, []);

	const getHomepage = async () => {
		setLoader(true);
		let res = await new HomePageController().homePage();
		if (res && res.status) {
			setHomepage(res.home_page);
		}
		setLoader(false);
	};


	const renderProcessSection = (list) => {
		let array = [];

		for (let i = 0; i < list.length; i++) {
			let item = list[i];
			array.push(
				(i + 1) % 2 === 0 ? <div key={i + 1} className="process_item process_2">
					<Animated animationIn="zoomIn" animationInDuration={500} animationInDelay={2550} isVisible={true}>
						<div className="row align-items-center">
							<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12  order-lg-0 order-1">
								<div className="process_content">
									<p>{stripTags(item.description)}</p>
								</div>
							</div>
							<div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
								<div className="process_img">
									<img src={renderImage(item.image, 'medium')} alt="..." className="img-fluid d-block mx-auto" />
								</div>
							</div>
							<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
								<div className="process_title">
									<h4>{i + 1}</h4>
									<hr />
									<h2>{item.title}</h2>
								</div>
							</div>
						</div>
					</Animated>
				</div> :
					<div key={i + 1} className="process_item process_1">
						<Animated animationIn="zoomIn" animationInDuration={500} animationInDelay={2200} isVisible={true}>
							<div className="row align-items-center">
								<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
									<div className="process_title">
										<h4>{i + 1}</h4>
										<hr />
										<h2>{item.title && item.title}</h2>
									</div>
								</div>
								<div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
									<div className="process_img">
										<img src={renderImage(item.image, 'medium')} alt="..." className="img-fluid d-block mx-auto" />
									</div>
								</div>
								<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
									<div className="process_content">
										<p>{stripTags(item.description)}</p>
									</div>
								</div>
							</div>
						</Animated>
					</div>
			);

		}
		return array;
	}



	return (
		<div className="homepage_section">
			<HomeSlider item={homepage ? homepage.slider_section : null} />
			<section className="about_section pt-5 pb-2">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="about_area">
								<div className="row">
									{homepage && homepage.about_us ? <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pb-5">
										<Animated animationIn="fadeInLeft" animationInDuration={700} animationInDelay={200} isVisible={true}>
											<div className="section_title right_line">
												<h2>{homepage.about_us.title}</h2>
												<div className="sub_title">
													<h3>{homepage.about_us.sub_title}</h3>
												</div>
											</div>
										</Animated>
										<Animated animationIn="fadeInLeft" animationInDuration={700} animationInDelay={400} isVisible={true}>
											<div className="cms_section text-justify ">
												<p>
													{homepage.about_us.description}
												</p>
											</div>
											{homepage.about_us.is_button == 1 ? <div className="secondary_btn">
												<Link to={homepage.about_us.button_link}>{homepage.about_us.button_text}<i className="far fa-angle-right"></i></Link>
											</div> : null}
										</Animated>
									</div> : null}
									{homepage && homepage.about_us ? <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pb-5">
										<div className="advantages_section">
											{homepage.about_us.features != null || '' ? <>
												{homepage.about_us.features.map((item, index) => (
													<Animated key={index} animationIn="fadeInRight" animationInDuration={400} animationInDelay={200} isVisible={true}>
														<div className="advantage_item bg_secondary">
															<div className="d-flex">
																<div className="icon_area">
																	<img src={renderImage(item.image)} className="img-fluid" alt="..." />
																</div>
																<div className="content_area">
																	<h5>{item.title}</h5>
																	<p>{charLimit(stripTags(item.description), 330)}</p>
																</div>
															</div>
														</div>
													</Animated>
												))}
											</> : null}
										</div>
									</div> : null}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="services_section bg-light pt-5 pb-4">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.our_services_section && <div className="services_area pb-3">
								{homepage.our_services_section.our_services.length > 0 ? <div className="section_title both_line text-center">
									<h2>{homepage.our_services_section.title}</h2>
								</div> : null}
								<div className="services_items">
									<EqualHeight>
										<div className="row justify-content-center">
											{homepage.our_services_section.our_services != null || '' ? <>
												{homepage.our_services_section && homepage.our_services_section.our_services.map((item, index) => (
													<div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
														<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={400} isVisible={true}>
															<div className="service_item">
																<EqualHeightElement>
																	<div className="icon_area">
																		<Link to={routes.service}>
																			<img src={renderImage(item.image, 'medium')} alt="..." className="img-fluid" />
																		</Link>
																	</div>
																	<div className="info_area">
																		<h4>
																			<Link to={routes.service}>{item.title}</Link>
																		</h4>
																		<p>{charLimit(stripTags(item.description), 230)}</p>
																	</div>
																</EqualHeightElement>
															</div>
														</Animated>
													</div>
												))}
											</> : null}
										</div>
									</EqualHeight>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</section>
			{homepage && homepage.our_process_section && homepage.our_process_section.our_process.length > 0 &&
				<section className="process_section pt-5 pb-4" style={{ backgroundImage: `url(${images.polygonBG})` }}>
					<div className="container">
						<div className="row">
							<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
								{homepage && homepage.our_process_section && homepage.our_process_section.our_process.length > 0 &&
									<div className="process_area ">
										<div className="section_title both_line text-center txt_white">
											<h2>{homepage.our_process_section.title}</h2>
										</div>
										{renderProcessSection(homepage.our_process_section.our_process)}

									</div>}
							</div>
						</div>
					</div>
				</section >}
			<section className="articles_section pt-5 pb-5 bg-light">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.articles_section && <div className="articles_area pb-3">
								{homepage.articles_section.articles.length > 0 && <div className="section_title both_line text-center">
									<h2>{homepage.articles_section.title}</h2>
								</div>}
								<ArticlesSlider item={homepage ? homepage.articles_section : null} />
							</div>}
						</div>
					</div>
				</div>
			</section>
			{/* <section className="work_section pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="work_area pb-3">
								<div className="section_title both_line text-center">
									<h2>Our Latest Work</h2>
								</div>
								<Animated animationIn="zoomIn" animationInDuration={900} animationInDelay={4400} isVisible={true}>
									<LatestWork />
								</Animated>
							</div>
						</div>
					</div>
				</div>
			</section> */}
			<section className="products_section bg-light pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.our_products_section && <div className="products_area">
								{homepage.our_products_section.our_products.length > 0 && <div className="section_title both_line text-center">
									<h2>{homepage.our_products_section.title}</h2>
								</div>}
								<div className="products_items">
									<div className="row justify-content-center">
										{homepage.our_products_section.our_products != null || '' ? <>
											{homepage.our_products_section && homepage.our_products_section.our_products.map((item, index) => (
												<div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
													<div className="product_item">
														<div className="product_img">
															<img src={renderImage(item.image, 'medium')} alt="..." className="img-fluid d-block mx-auto" />
															<div className="upper_image">
																{homepage.our_products_section.is_button === 1 ? <div className="secondary_btn text-center">
																	<Link to={{
																		pathname: homepage.our_products_section.button_link,
																		id: item.id
																	}}>{homepage.our_products_section.button_text} <i className="far fa-angle-right"></i></Link>
																</div> : null}
															</div>
														</div>
														<div className="product_info">
															<h4>{item.title}</h4>
															<p>{charLimit(stripTags(item.description), 150)}</p>
														</div>
													</div>
												</div>
											))}
										</> : null}
									</div>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</section >
			<section className="technologies_section pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.technology_partners_section && <div className="technologies_area">
								{homepage.technology_partners_section.technology_partners.length > 0 && <div className="section_title both_line text-center txt_white">
									<h2>Technology Partners</h2>
								</div>}
								<TechnologiesSlider item={homepage ? homepage.technology_partners_section : null} />
							</div>}
						</div>
					</div>
				</div>
			</section>
			<section className="news_section pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.news_section && <div className="news_area">
								<div className="section_title both_line text-center">
									<h2>{homepage.news_section.title}</h2>
								</div>
								<div className="news_items">
									<div className="row">
										{homepage.news_section.news != null || '' ? <>
											{homepage.news_section && homepage.news_section.news.map((item, index) => (
												<div key={index} className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
													<div className="news_item">
														<Link to={{
															pathname: "/newsdetail",
															id: item.id
														}}>
															<div className="news_img embed-responsive embed-responsive-16by9">
																<img src={renderImage(item.image, 'medium')} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
															</div>
															<div className="news_info">
																<div className="d-flex">
																	{item.categories.map((item, index) => (

																		<div key={index} className="category_name">
																			<span>{item.title}</span>
																		</div>
																	))}
																	<div className="news_date">
																		<span>{dateFormat(item.created)}</span>
																	</div>
																</div>
																<h4>{item.title}</h4>
															</div>
														</Link>
													</div>
												</div>
											))}
										</> : null}
									</div>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</section>
			{homepage && homepage.testimonials_section.testimonials.length > 0 && <section className="testimonials_section pt-5 pb-5" style={{ backgroundImage: `url(${images.process2})` }}>
				<div className="testimonials_area">
					<div className="container">
						<div className="row">
							{homepage && homepage.testimonials_section && <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
								<div className="section_title both_line text-center">
									<h2>Testimonials</h2>
								</div>
								<div className="row justify-content-center">
									<div className="col-xl-9 col-lg-10 col-md-11 col-sm-12 col-12">
										<TestimonialSlider item={homepage ? homepage.testimonials_section : null} />
									</div>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</section>}
			{homepage && homepage.our_accolades_section.our_accolades.length > 0 && <section className="accolades_section pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.our_accolades_section && <div className="accolades_area">
								<div className="section_title both_line text-center">
									<h2>Our Accolades</h2>
								</div>
								<AccoladesSlider item={homepage ? homepage.our_accolades_section : null} />
							</div>}
						</div>
					</div>
				</div>
			</section>}
		</div >
	);
}

export default HomePage;
